import { SimpleNodeData } from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";

export const extractCodeNodeFields = (
  data: SimpleNodeData,
  nodeId: string,
): SearchableField[] => {
  return [
    {
      id: `${nodeId}:src`,
      value: data.src,
    },
  ];
};
